import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import { BuildBadge } from '@ledium/ui-build-badge';
import { Header } from '@ledium/ui-header';
import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';

import { GlobalErrorBoundary } from './components/GlobalErrorBoundary';
import { UxProvider } from './context/UxContext';
import theme from './ledium-theme';
import LediumRouter from './LediumRouter';
import { GlobalStoreProvider } from './store/globalStore/context/globalContext';

function App() {
    return (
        <>
            <GlobalErrorBoundary>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                        <CssBaseline />
                        <GlobalStoreProvider>
                            <Router>
                                <Switch>
                                    <UxProvider>
                                        <Header>
                                            <LediumRouter />
                                        </Header>
                                    </UxProvider>
                                </Switch>
                            </Router>
                        </GlobalStoreProvider>
                    </ThemeProvider>
                </StyledEngineProvider>
            </GlobalErrorBoundary>
            <BuildBadge />
        </>
    );
}

export default App;
